(() => {
  if (customElements.get("gift-card-recipient-form")) {
    return;
  }

  class GiftCardRecipientForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener('change', (event) => {
        event.stopPropagation();
      })

      this.checkbox = this.querySelector("[data-checker]");

      this.checkbox.addEventListener(
        "change",
        this.cleanFields.bind(this)
      );
    }

    cleanFields(event) {
      event.stopPropagation();
      event.stopImmediatePropagation();

      this.querySelector("[data-recipient-fields]")
        .querySelectorAll("*[id^=Recipient]")
        .forEach((field) => (field.value = ""));
    }
  }

  customElements.define("gift-card-recipient-form", GiftCardRecipientForm);
})();
